// Copyright 2021 The Casdoor Authors. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import React from "react";
import {Button, Card, Col, Input, Row, Select, Switch} from "antd";
import {LinkOutlined} from "@ant-design/icons";
import * as OrganizationBackend from "../../services/OrganizationBackend";
import * as ApplicationBackend from "../../services/ApplicationBackend";
import * as LdapBackend from "../../services/LdapBackend";
import * as Setting from "../../conf/Setting";
import i18next from "i18next";
import moment from "moment";
import CropperDiv from "../../components/common/CropperDiv.js";
import GlobalContext from "../../context/GlobalContext";
import * as PasswordPolicyBackend from "../../services/PasswordPolicyBackend";
import * as AccountActivationBackend from "../../services/AccountActivationBackend";

// import {LinkOutlined} from "@ant-design/icons";
// import LdapTable from "./LdapTable";
// import AccountTable from "./AccountTable";
// import {JSEncrypt} from "jsencrypt";

const {Option} = Select;

class OrganizationEditPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      classes: props,
      organizationId: props.organizationId !== undefined ? props.organizationId : props.match.params.organizationId,
      displayName: props.displayName,
      organization: null,
      applications: [],
      ldaps: null,
      mode: props.mode !== undefined ? props.mode :
        (props.location.mode !== undefined ? props.location.mode : "edit"),
      passwordPolicies: [],
      accountActivationConfigs: [],
    };
  }

  UNSAFE_componentWillMount() {
    this.getPasswordPolicy();
    this.getOrganization();
    this.getApplications();
    this.getLdaps();
    this.getAccountActivationConfigs();
  }

  getPasswordPolicy() {
    PasswordPolicyBackend.getConfigs().then(res => {
      if (res.msg === undefined) {
        this.setState({
          passwordPolicies: res.filter(item => !item.isForbidden),
        });
      } else {
        Setting.showResponseMessage(res.msg);
      }
    }).catch(error => {
      Setting.showResponseMessage(error);
    });
  }

  getOrganization() {
    OrganizationBackend.getOrganization(Setting.Admin, this.state.organizationId)
      .then((organization) => {
        this.setState({
          organization: organization,
        });
      });
  }

  getApplications() {
    ApplicationBackend.getApplicationsByOrganization(Setting.Admin, this.state.organizationId)
      .then((applications) => {
        this.setState({
          applications: applications,
        });
      });
  }

  getLdaps() {
    LdapBackend.getLdaps(this.state.organizationId)
      .then(res => {
        let resdata = [];
        if (res.status === "ok") {
          if (res.data !== null) {
            resdata = res.data;
          }
        }
        this.setState({
          ldaps: resdata,
        });
      });
  }

  getAccountActivationConfigs() {
    AccountActivationBackend.getConfigs(Setting.Admin)
      .then(res => {
        if (res.msg === undefined) {
          this.setState({
            accountActivationConfigs: res,
          });
        } else {
          Setting.showResponseMessage(res.msg);
        }
      }).catch(error => {
        Setting.showResponseMessage(error);
      });
  }

  parseOrganizationField(key, value) {
    // if ([].includes(key)) {
    //   value = Setting.myParseInt(value);
    // }
    return value;
  }

  updateOrganizationField(key, value) {
    value = this.parseOrganizationField(key, value);

    const organization = this.state.organization;
    organization[key] = value;
    this.setState({
      organization: organization,
    });
  }

  renderOrganization() {
    return (
      <Card size="small" title={
        <div>
          {this.state.mode === "add" ? i18next.t("organization:New Organization") : i18next.t("organization:Edit Organization")}&nbsp;&nbsp;&nbsp;&nbsp;
          <Button onClick={() => this.submitOrganizationEdit(false)}>{i18next.t("general:Save")}</Button>
          <Button style={{marginLeft: "20px"}} type="primary" onClick={() => this.submitOrganizationEdit(true)}>{i18next.t("general:Save & Exit")}</Button>
          {this.state.mode === "add" ? <Button style={{marginLeft: "20px"}} onClick={() => this.deleteOrganization()}>{i18next.t("general:Cancel")}</Button> :
            <Button style={{marginLeft: "20px"}} onClick={() => this.exit()}>{i18next.t("general:Cancel")}</Button>}
        </div>
      } style={(Setting.isMobile()) ? {margin: "5px"} : {}} type="inner">
        <Row style={{marginTop: "10px"}} >
          <Col style={{marginTop: "5px"}} span={(Setting.isMobile()) ? 22 : 2}>
            {Setting.getLabel(i18next.t("general:ID"), i18next.t("general:ID - Tooltip"))} :
          </Col>
          <Col span={22} >
            <Input defaultValue={this.state.organization.uid} disabled={true} onChange={e => {
              this.updateOrganizationField("name", e.target.value);
            }} />
          </Col>
        </Row>
        <Row style={{marginTop: "20px"}} >
          <Col style={{marginTop: "5px"}} span={(Setting.isMobile()) ? 22 : 2}>
            {Setting.getLabel(i18next.t("organization:Display name"), i18next.t("organization:Display name - Tooltip"), true)} :
          </Col>
          <Col span={22} >
            <Input value={this.state.organization.displayName}
              disabled={Setting.isAdminOrganization(this.state.organization.uid)}
              placeholder={i18next.t("general:Limited number of characters is {number}").replace("{number}", 50)}
              onChange={e => {
                this.updateOrganizationField("displayName", e.target.value);
              }} />
          </Col>
        </Row>
        <Row style={{marginTop: "20px"}} >
          <Col style={{marginTop: "5px"}} span={(Setting.isMobile()) ? 22 : 2}>
            {Setting.getLabel(i18next.t("organization:Organization code"), i18next.t("organization:Organization code - Tooltip"))} :
          </Col>
          <Col span={22} >
            <Input value={this.state.organization.code}
              disabled={Setting.isAdminOrganization(this.state.organization.uid)}
              placeholder={i18next.t("general:Limited number of characters is {number}").replace("{number}", 30)}
              onChange={e => {
                this.updateOrganizationField("code", e.target.value);
              }} />
          </Col>
        </Row>
        <Row style={{marginTop: "20px"}} >
          <Col style={{marginTop: "5px"}} span={(Setting.isMobile()) ? 22 : 2}>
            {Setting.getLabel(i18next.t("general:Favicon"), i18next.t("general:Favicon - Tooltip"))} :
          </Col>
          <Col span={22} >
            <Row style={{marginTop: "20px"}} >
              <Col style={{marginTop: "5px"}} span={(Setting.isMobile()) ? 22 : 1}>
                {Setting.getLabel(i18next.t("general:URL"), i18next.t("general:URL - Tooltip"))} :
              </Col>
              <Col span={23} >
                <Input prefix={<LinkOutlined />}
                  disabled={true}
                  value={this.state.organization.favicon} onChange={e => {
                    this.updateOrganizationField("favicon", e.target.value);
                  }} />
              </Col>
            </Row>
            <Row style={{marginTop: "20px"}} >
              <Col style={{marginTop: "5px"}} span={(Setting.isMobile()) ? 22 : 1}>
                {i18next.t("general:Preview")}:
              </Col>
              <Col span={23} >
                {
                  this.state.organization.favicon === "" ?
                    <img src={require("../../assets/images/default_icon.png")} alt={""} height={90} style={{marginBottom: "20px"}} />
                    :
                    <a target="_blank" rel="noreferrer" href={this.state.organization.favicon}>
                      <img src={this.state.organization.favicon} alt={""} height={90} style={{marginBottom: "20px"}} />
                    </a>
                }
              </Col>
            </Row>
            <Row style={{marginTop: "20px"}}>
              <GlobalContext.Consumer>
                {
                  ({account, updateAccount}) => (
                    <CropperDiv
                      getNewPicUrl={(url) => {
                        this.updateOrganizationField("favicon", url);
                        if (Setting.isAdminOrganization(this.state.organization.uid)) {
                          const {...organization} = this.props.account;
                          organization.favicon = url;
                          const newAccount = {...this.props.account, ...{organization: organization}};
                          updateAccount(newAccount);
                        }
                      }}
                      buttonText={`${i18next.t("general:Upload a photo")}`}
                      title={i18next.t("general:Upload a photo")}
                      objId={this.state.organization.uid}
                      account={this.props.account}
                      type="organization"
                    />
                  )
                }
              </GlobalContext.Consumer>
            </Row>
          </Col>
        </Row>
        <Row style={{marginTop: "20px"}} >
          <Col style={{marginTop: "5px"}} span={(Setting.isMobile()) ? 22 : 2}>
            {Setting.getLabel(i18next.t("organization:Password Policy"), i18next.t("organization:Password Policy - Tooltip"), true)} :
          </Col>
          <Col span={22} >
            <Select virtual={false} style={{width: "100%"}} value={this.state.organization.pwdConfig} onChange={(value => {this.updateOrganizationField("pwdConfig", value);})}>
              {
                this.state.passwordPolicies?.map((item, index) => <Option key={index} value={item.uid}>{item.displayName}</Option>)
              }
            </Select>
          </Col>
        </Row>
        <Row style={{marginTop: "20px"}} >
          <Col style={{marginTop: "5px"}} span={(Setting.isMobile()) ? 19 : 2}>
            {Setting.getLabel(i18next.t("organization:Account Activate"), i18next.t("organization:Account Activate - Tooltip"))} :
          </Col>
          <Col span={1} >
            <Switch
              disabled={Setting.isAdminOrganization(this.state.organization.uid)}
              checkedChildren={i18next.t("general:Yes")}
              unCheckedChildren={i18next.t("general:No")}
              checked={this.state.organization.needActivation} onChange={checked => {
                this.updateOrganizationField("needActivation", checked);
                if (!checked) {
                  this.updateOrganizationField("acctActConf", "");
                } else {
                  const accActConfig = this.state.accountActivationConfigs[0];
                  this.updateOrganizationField("acctActConf", accActConfig.uid);
                }
              }} />
          </Col>
          {
            this.state.organization.needActivation ?
              <Col span={4}>
                <Select virtual={false} style={{width: "100%"}} value={this.state.organization.acctActConf} onChange={(value => {this.updateOrganizationField("acctActConf", value);})}>
                  {
                    this.state.accountActivationConfigs?.map((item, index) => <Option key={item.uid} value={item.uid}>{item.displayName}</Option>)
                  }
                </Select>
              </Col>
              :
              null
          }
        </Row>
        {/* <Row style={{marginTop: "20px"}} >
          <Col style={{marginTop: "5px"}} span={(Setting.isMobile()) ? 22 : 2}>
            {Setting.getLabel(i18next.t("organization:Website URL"), i18next.t("organization:Website URL - Tooltip"))} :
          </Col>
          <Col span={22} >
            <Input prefix={<LinkOutlined />} value={this.state.organization.websiteUrl} onChange={e => {
              this.updateOrganizationField("websiteUrl", e.target.value);
            }} />
          </Col>
        </Row>
        <Row style={{marginTop: "20px"}} >
          <Col style={{marginTop: "5px"}} span={(Setting.isMobile()) ? 22 : 2}>
            {Setting.getLabel(i18next.t("general:Password type"), i18next.t("general:Password type - Tooltip"))} :
          </Col>
          <Col span={22} >
            <Select virtual={false} style={{width: "100%"}} value={this.state.organization.passwordType} onChange={(value => {this.updateOrganizationField("passwordType", value);})}>
              {
                ["plain", "salt", "md5-salt", "bcrypt", "pbkdf2-salt", "argon2id"]
                  .map((item, index) => <Option key={index} value={item}>{item}</Option>)
              }
            </Select>
          </Col>
        </Row>
        <Row style={{marginTop: "20px"}} >
          <Col style={{marginTop: "5px"}} span={(Setting.isMobile()) ? 22 : 2}>
            {Setting.getLabel(i18next.t("general:Password salt"), i18next.t("general:Password salt - Tooltip"))} :
          </Col>
          <Col span={22} >
            <Input value={this.state.organization.passwordSalt} onChange={e => {
              this.updateOrganizationField("passwordSalt", e.target.value);
            }} />
          </Col>
        </Row>
        <Row style={{marginTop: "20px"}} >
          <Col style={{marginTop: "5px"}} span={(Setting.isMobile()) ? 22 : 2}>
            {Setting.getLabel(i18next.t("general:Phone prefix"), i18next.t("general:Phone prefix - Tooltip"))} :
          </Col>
          <Col span={22} >
            <Input addonBefore={"+"} value={this.state.organization.phonePrefix} onChange={e => {
              this.updateOrganizationField("phonePrefix", e.target.value);
            }} />
          </Col>
        </Row>
        <Row style={{marginTop: "20px"}} >
          <Col style={{marginTop: "5px"}} span={(Setting.isMobile()) ? 22 : 2}>
            {Setting.getLabel(i18next.t("general:Default avatar"), i18next.t("general:Default avatar - Tooltip"))} :
          </Col>
          <Col span={22} >
            <Row style={{marginTop: "20px"}} >
              <Col style={{marginTop: "5px"}} span={(Setting.isMobile()) ? 22 : 1}>
                {Setting.getLabel(i18next.t("general:URL"), i18next.t("general:URL - Tooltip"))} :
              </Col>
              <Col span={23} >
                <Input prefix={<LinkOutlined />} value={this.state.organization.defaultAvatar} onChange={e => {
                  this.updateOrganizationField("defaultAvatar", e.target.value);
                }} />
              </Col>
            </Row>
            <Row style={{marginTop: "20px"}} >
              <Col style={{marginTop: "5px"}} span={(Setting.isMobile()) ? 22 : 1}>
                {i18next.t("general:Preview")}:
              </Col>
              <Col span={23} >
                <a target="_blank" rel="noreferrer" href={this.state.organization.defaultAvatar}>
                  <img src={this.state.organization.defaultAvatar} alt={this.state.organization.defaultAvatar} height={90} style={{marginBottom: "20px"}} />
                </a>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row style={{marginTop: "20px"}} >
          <Col style={{marginTop: "5px"}} span={(Setting.isMobile()) ? 22 : 2}>
            {Setting.getLabel(i18next.t("general:Default application"), i18next.t("general:Default application - Tooltip"))} :
          </Col>
          <Col span={22} >
            <Select virtual={false} style={{width: "100%"}} value={this.state.organization.defaultApplication} onChange={(value => {this.updateOrganizationField("defaultApplication", value);})}>
              {
                this.state.applications?.map((item, index) => <Option key={index} value={item.name}>{item.name}</Option>)
              }
            </Select>
          </Col>
        </Row>
        <Row style={{marginTop: "20px"}} >
          <Col style={{marginTop: "5px"}} span={(Setting.isMobile()) ? 22 : 2}>
            {Setting.getLabel(i18next.t("organization:Tags"), i18next.t("organization:Tags - Tooltip"))} :
          </Col>
          <Col span={22} >
            <Select virtual={false} mode="tags" style={{width: "100%"}} value={this.state.organization.tags} onChange={(value => {this.updateOrganizationField("tags", value);})}>
              {
                this.state.organization.tags?.map((item, index) => <Option key={index} value={item}>{item}</Option>)
              }
            </Select>
          </Col>
        </Row>
        <Row style={{marginTop: "20px"}} >
          <Col style={{marginTop: "5px"}} span={(Setting.isMobile()) ? 22 : 2}>
            {Setting.getLabel(i18next.t("general:Master password"), i18next.t("general:Master password - Tooltip"))} :
          </Col>
          <Col span={22} >
            <Input value={this.state.organization.masterPassword} onChange={e => {
              this.updateOrganizationField("masterPassword", e.target.value);
            }} />
          </Col>
        </Row>
        <Row style={{marginTop: "20px"}} >
          <Col style={{marginTop: "5px"}} span={(Setting.isMobile()) ? 19 : 2}>
            {Setting.getLabel(i18next.t("organization:Soft deletion"), i18next.t("organization:Soft deletion - Tooltip"))} :
          </Col>
          <Col span={1} >
            <Switch checked={this.state.organization.enableSoftDeletion} onChange={checked => {
              this.updateOrganizationField("enableSoftDeletion", checked);
            }} />
          </Col>
        </Row>
        <Row style={{marginTop: "20px"}} >
          <Col style={{marginTop: "5px"}} span={(Setting.isMobile()) ? 19 : 2}>
            {Setting.getLabel(i18next.t("organization:Is profile public"), i18next.t("organization:Is profile public - Tooltip"))} :
          </Col>
          <Col span={1} >
            <Switch checked={this.state.organization.isProfilePublic} onChange={checked => {
              this.updateOrganizationField("isProfilePublic", checked);
            }} />
          </Col>
        </Row>
        <Row style={{marginTop: "20px"}} >
          <Col style={{marginTop: "5px"}} span={(Setting.isMobile()) ? 22 : 2}>
            {Setting.getLabel(i18next.t("organization:Account items"), i18next.t("organization:Account items - Tooltip"))} :
          </Col>
          <Col span={22} >
            <AccountTable
              title={i18next.t("organization:Account items")}
              table={this.state.organization.accountItems}
              onUpdateTable={(value) => {this.updateOrganizationField("accountItems", value);}}
            />
          </Col>
        </Row>
        <Row style={{marginTop: "20px"}}>
          <Col style={{marginTop: "5px"}} span={(Setting.isMobile()) ? 22 : 2}>
            {Setting.getLabel(i18next.t("general:LDAPs"), i18next.t("general:LDAPs - Tooltip"))} :
          </Col>
          <Col span={22}>
            <LdapTable
              title={i18next.t("general:LDAPs")}
              table={this.state.ldaps}
              organizationId={this.state.organizationId}
              onUpdateTable={(value) => {
                this.setState({ldaps: value});
              }}
            />
          </Col>
        </Row> */}
      </Card>
    );
  }

  submitOrganizationEdit(willExist) {
    const organization = Setting.deepCopy(this.state.organization);
    if (organization.masterPassword !== "***" && organization.masterPassword !== "") {
      // const encrypt = new JSEncrypt();
      // encrypt.setPublicKey(this.props.publicKey);
      // organization.masterPassword = encrypt.encrypt(organization.masterPassword);
    }
    if (organization.displayName.trim() === "") {
      Setting.showMessage("error", i18next.t("organization:Please input display name"));
      return;
    }

    if (organization.displayName.length > 50) {
      Setting.showMessage("error", i18next.t("organization:Display name is limited in 50 characters"));
      return;
    }

    if (organization.code.length > 30) {
      Setting.showMessage("error", i18next.t("organization:Code is limited in 30 characters"));
      return;
    }

    if (organization.needActivation && organization.acctActConf === "") {
      Setting.showMessage("error", i18next.t("请选择激活配置"));
      return;
    }

    organization.updatedTime = moment().format("yyyy-MM-DD HH:mm:ss");
    OrganizationBackend.updateOrganization(this.state.organization.owner, this.state.organizationId, organization)
      .then((res) => {
        if (res.status === "ok") {
          Setting.showMessage("success", i18next.t("general:Successfully saved"));
          this.setState({
            displayName: this.state.organization.displayName,
          });

          if (this.props.onFinishedSubmit !== undefined) {
            if (willExist) {
              this.props.onFinishedSubmit(this.state.organization);
            } else {
              this.setState({mode: "edit"});
            }
          } else {
            // if (willExist) {
            //   this.props.history.push("/organizations");
            // } else {
            //   this.props.history.push(`/organizations/${this.state.organization.uid}`);
            // }
          }
        } else {
          Setting.showResponseMessage(res.msg);
          if (this.state.displayName !== undefined) {
            this.updateOrganizationField("displayName", this.state.displayName);
          }
        }
      })
      .catch(error => {
        Setting.showResponseMessage(error);
      });
  }

  deleteOrganization() {
    OrganizationBackend.deleteOrganization(this.state.organization)
      .then(() => {
        // this.props.history.push("/organizations");
        this.props.onDeleteOrganization();
      })
      .catch(error => {
        Setting.showResponseMessage(error);
      });
  }

  exit() {
    if (this.props.onFinishedSubmit !== undefined) {
      this.props.onFinishedSubmit();
    }
  }

  render() {
    return (
      <div>
        {
          this.state.organization !== null ? this.renderOrganization() : null
        }
        <div style={{marginTop: "20px", marginLeft: "40px"}}>
          <Button size="large" onClick={() => this.submitOrganizationEdit(false)}>{i18next.t("general:Save")}</Button>
          <Button style={{marginLeft: "20px"}} type="primary" size="large" onClick={() => this.submitOrganizationEdit(true)}>{i18next.t("general:Save & Exit")}</Button>
          {this.state.mode === "add" ? <Button style={{marginLeft: "20px"}} size="large" onClick={() => this.deleteOrganization()}>{i18next.t("general:Cancel")}</Button> :
            <Button style={{marginLeft: "20px"}} onClick={() => this.exit()}>{i18next.t("general:Cancel")}</Button>}
        </div>
      </div>
    );
  }
}

export default OrganizationEditPage;
